var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container-custom",staticStyle:{"height":"100%"}},[_c('v-row',[_c('Breadcrumbs',{attrs:{"title":_vm.breadcrumbs.title}})],1),_c('v-row',{attrs:{"justify":"center"}},[_c('ApplicationEdit',{attrs:{"myData":_vm.myData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }